// extracted by mini-css-extract-plugin
export default {"logo":"logo-v1_logo__lWODM","medium":"logo-v1_medium__oiOVZ"};